import React from 'react';
import { Button } from 'react-bootstrap';
import {PencilSquare } from 'react-bootstrap-icons';

const EditButtonCellRender = (props) => {
  const onClick = () => {
    props.onEdit(props.data);
  };

  return <button className='tableButton' data-type='modalEditButton'  onClick={onClick}><PencilSquare /></button>;
};

export default EditButtonCellRender;